import { useUiStore } from '@/stores';
import { enGB, it } from 'date-fns/locale';
import { toZonedTime, format as formatTz } from 'date-fns-tz';
import { getUserPreferenceValue } from '../utils/user-preferences-utils';
import { format, parseISO, formatDuration, intervalToDuration, formatDistance } from 'date-fns';
import { USER_PREFERENCE_KEY_LANGUAGE, LanguageCodes } from '@/shared/constants';

const dateFormatsPrimevue = {
  [LanguageCodes.en]: 'mm/dd/yy',
  [LanguageCodes.it]: 'dd/mm/yy',
};

const dateFormats = {
  [LanguageCodes.en]: 'MM/dd/yyyy',
  [LanguageCodes.it]: 'dd/MM/yyyy',
};

//
// Deprecated - use/migrate to composable use-date-utils insted
//
const dateUtils = {
  getPrimeDateFormat: () => {
    const langCode: string = getUserPreferenceValue(USER_PREFERENCE_KEY_LANGUAGE, LanguageCodes.en);
    return dateFormatsPrimevue[langCode];
  },

  getDateTimeFormat: (timeFormat = 'HH:mm') => {
    const langCode: string = getUserPreferenceValue(USER_PREFERENCE_KEY_LANGUAGE, LanguageCodes.en);
    return dateFormats[langCode] + ' ' + timeFormat;
  },

  formatDateToCulture: (date: string | undefined) => {
    if (date) {
      const uiStore = useUiStore();
      const dt: Date = parseISO(date);
      const dtFormat: string = uiStore.getDateFormat || 'dd/MM/yyyy';
      if (dt instanceof Date) {
        return format(dt, dtFormat);
      }
    }
    return '';
  },

  convertIsoStringToLocaleDate(isoValue: string | null | undefined) {
    if (isoValue && isoValue.length) {
      if (isoValue.toString().indexOf('.') === -1) {
        isoValue = isoValue.substring(0, isoValue.length - 1) + '.000Z';
      }
      return new Date(isoValue);
    }

    return undefined;
  },

  formatDateTimeToCulture: (date: string, toLocal = true) => {
    return date !== null ? format(parseISO(date), 'dd/MM/yyyy HH:mm') : '';
  },

  convertDateToIsoStringWithoutOffset(date: Date): string {
    // ISO date format example 2020-12-30T11:50:44.56Z
    const prependMonth = date.getMonth() + 1 < 10 ? '0' : '';
    const prependDay = date.getDate() < 10 ? '0' : '';
    return `${date.getFullYear()}-${prependMonth}${date.getMonth() + 1}-${prependDay}${date.getDate()}T00:00:00.00Z`;
  },

  humanizeDuration(duration: number, showMilis: boolean): string {
    const seconds = Math.floor(duration / 1000);
    const milliseconds = duration - seconds * 1000;
    const intervalDuration = intervalToDuration({ start: 0, end: seconds * 1000 });
    const formatedDuration = formatDuration(intervalDuration);
    const convertDuration = formatedDuration
      .replace('years', 'Y')
      .replace('year', 'Y')
      .replace('months', 'M')
      .replace('month', 'M')
      .replace('weeks', 'W')
      .replace('week', 'W')
      .replace('days', 'd')
      .replace('day', 'd')
      .replace('hours', 'h')
      .replace('hour', 'h')
      .replace('minutes', 'm')
      .replace('minute', 'm')
      .replace('seconds', 's')
      .replace('second', 's');
    if (showMilis) return convertDuration + (convertDuration ? ' ' : '') + milliseconds + ' ms';
    else return convertDuration;
  },

  getHumanizedDuration(utc: string) {
    const now = new Date();
    const dateFrom = new Date(utc);
    const humanizedDuration = formatDistance(dateFrom, now, { addSuffix: true });
    return humanizedDuration;
  },

  getHumanizedDurationLanguage(utc: string, language: string) {
    const now = new Date();
    const dateFrom = new Date(utc);

    const locale = language === 'it-IT' ? it : enGB;

    return formatDistance(dateFrom, now, {
      addSuffix: true,
      locale,
    });
  },

  formatUtcToLocalTimeFormat(utc: string) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return utc ? formatTz(toZonedTime(utc, timeZone), dateUtils.getDateTimeFormat(), { timeZone }) : '';
  },
};
export { dateUtils };
